import {
  CREATE_LOCATION_SUCCESS,
  FETCH_LOCATION_SUCCESS,
  GET_LOCATION_SUCCESS,
  SAVE_LOCATION_QUERY
} from "../../constants/ActionTypes";

const INIT_STATE = {
  total: 0,
  resources: [],
  resource: {},
  edit: {},
  query: {},
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SAVE_LOCATION_QUERY: {
      return {
        ...state,
        query: action.query
      }
    }

    case GET_LOCATION_SUCCESS: {
      const query = {...state.query};
      query.pagination.total = action.count;

      return {
        ...state,
        query: query,
        resources: action.data,
        total: action.total,
      }
    }

    case CREATE_LOCATION_SUCCESS: {
      return {
        ...state,
        resource: action.data,
      }
    }

    case FETCH_LOCATION_SUCCESS: {
      return {
        ...state,
        edit: action.data,
      }
    }


    default:
      return state;
  }
}
